import React from "react";
import DetailePageStyles from "../../../../utilities/DetailePageStayles";
import AttachmentPreview from "../MonitoringCgsDetails/AttachmentPreview";
import { ATTACHMENT_KEYS, AttachmentKey } from "../../../../types";

type TableComponentProps = {
    tableSchema: {
        fields: {
            name: string;
            label: string;
            colSpan?: number;
        }[];
    }[];
    data: any;
    getMappedValue: <T extends { name: string }, U>(
        field: T,
        data: U,
        mappers?: Record<string, (value: any) => any>
    ) => any;
    monitoringValueMappers?: any;
};

const MonitoringFieldsSchemaTable: React.FC<TableComponentProps> = ({
    tableSchema,
    data,
    getMappedValue,
    monitoringValueMappers,
}) => {
    const classes = DetailePageStyles();

    return (
        <table className={classes.table}>
            <thead>
                <tr>
                    <th style={{ fontSize: 12, textAlign: "left", padding: 8, width: "33.33%" }}>
                        პროექტის ფარგლებში განხორციელებული ხარჯვა;
                    </th>
                    <th style={{ fontSize: 12, textAlign: "left", padding: 8, width: "33.33%" }}>
                        მიზნობრივი ხარჯვა;
                    </th>
                    <th
                        colSpan={2}
                        style={{ fontSize: 12, textAlign: "left", padding: 8, width: "33.33%" }}
                    >
                        არამიზნობრივი ხარჯვა;
                        <i
                            style={{
                                display: "block",
                                fontSize: 10,
                                fontWeight: 100,
                                color: "rgba(0,0,0,0.8)",
                            }}
                        >
                            (მოიცავს შემდეგს: არ არის შეძენილი გუდვილი; არ არის შეძენილი სატრანსპორტო
                            საშუალებები და არ განხორციელებულა მათი რემონტი, გარდა სპეციალური საშუალებებისა…)
                        </i>
                    </th>
                </tr>
            </thead>

            <tbody>
                {tableSchema.map((row, index) => {
                    const fields = row.fields ?? [];

                    const attachmentField = fields.find((field) =>
                        ATTACHMENT_KEYS.includes(field.name as AttachmentKey)
                    );

                    return (
                        <React.Fragment key={index}>
                            {/* ───── Label row ───── */}
                            <tr
                                style={{
                                    backgroundColor: "#fafafa",
                                    borderTop: "1px solid rgba(0,0,0,0.12)",
                                }}
                            >
                                {fields.map((field) => (
                                    <td
                                        key={field.name}
                                        colSpan={field.colSpan ?? 1}
                                        style={{
                                            padding: 4,
                                            fontSize: 11,
                                            color: "rgba(0,0,0,0.54)",
                                            borderBottom: "none",
                                        }}
                                    >
                                        {field.label}
                                    </td>
                                ))}

                                <td
                                    style={{
                                        padding: 4,
                                        fontSize: 11,
                                        color: "rgba(0,0,0,0.54)",
                                        borderBottom: "none",
                                    }}
                                >
                                    {attachmentField ? "დოკუმენტი" : ""}
                                </td>
                            </tr>

                            {/* ───── Value row ───── */}
                            <tr style={{ borderBottom: "1px solid rgba(0,0,0,0.23)" }}>
                                {fields.map((field) => {
                                    return (
                                        <td
                                            key={field.name}
                                            colSpan={field.colSpan ?? 1}
                                            style={{ padding: 4 }}
                                        >
                                            {getMappedValue(field, data, monitoringValueMappers)}
                                        </td>
                                    )
                                })}

                                <td style={{ padding: 4 }}>
                                    {attachmentField && (
                                        <AttachmentPreview
                                            attachments={
                                                data?.attached_documents?.[attachmentField.name]
                                            }
                                        />
                                    )}
                                </td>
                            </tr>
                        </React.Fragment>
                    );
                })}
            </tbody>
        </table>
    );
};

export default MonitoringFieldsSchemaTable;
